import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelinePentagonIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g clipPath="url(#clip0_4003_40705)">
        <g filter="url(#filter0_d_4003_40705)">
          <path
            d="M9.12535 4.49233C9.58401 3.98209 10.4114 3.98454 10.8501 4.51208C11.8652 5.73294 13.0202 6.70522 14.8031 7.44555C15.4768 7.72527 15.7404 8.60206 15.3837 9.23835C14.5608 10.7064 14.1687 12.4273 13.9884 14.0058C13.9126 14.6698 13.2456 15.1156 12.5932 14.9706C10.9507 14.6055 9.23208 14.624 7.35748 15.0259C6.72282 15.162 6.09758 14.7129 6.03307 14.067C5.85215 12.2555 5.42131 10.7447 4.44092 9.07417C4.10481 8.50147 4.34869 7.74603 4.95564 7.47664C6.64108 6.72857 8.00409 5.73966 9.12535 4.49233Z"
            fill="#2E81DA"
          />
          <path
            d="M8.38123 3.82422C9.23302 2.87665 10.7763 2.86015 11.6185 3.87305C12.5459 4.98841 13.5749 5.85311 15.1869 6.52246C16.4623 7.05237 16.8789 8.61674 16.2562 9.72754C15.5241 11.0337 15.1544 12.6076 14.9818 14.1191C14.8343 15.4108 13.5705 16.2125 12.3763 15.9473C10.8928 15.6175 9.32049 15.6279 7.56677 16.0039C6.35803 16.2628 5.16312 15.4143 5.03845 14.166C4.86996 12.4793 4.47671 11.1106 3.57849 9.58008C2.93968 8.49135 3.39895 7.07346 4.55017 6.5625C6.11337 5.86865 7.35905 4.96121 8.38123 3.82422Z"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4003_40705"
          x="0.288376"
          y="1.11328"
          width="19.2506"
          height="18.937"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40705" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40705" result="shape" />
        </filter>
        <clipPath id="clip0_4003_40705">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default TimelinePentagonIcon;
